"use client";

import { TestSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedTestSection from "../Components/GeneratedTestSection";

const Test: FC<TestSectionProps> = (props) => {
  return <GeneratedTestSection {...props} />;
};

export default Test;
